import { Component, OnInit } from '@angular/core';
import { ViewWillEnter } from '@ionic/angular';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { GarmentRepairService } from '../../../../services/garment-repair.service';
import { ToasterService } from '../../../../../../../app/common/services/toaster.service';


@Component({
  selector: 'app-garment-repair-page',
  templateUrl: 'garment-repair.page.html',
  styleUrls: [
     './garment-repair.page.scss',
     '../../../../styles/g-route.styles.scss'
  ]
})
export class GarmentRepairPage implements ViewWillEnter, OnInit {

    currentRoute: string;
    stopName: string;
    breadcrumbs=[];
    messageCode: string;
    garmentCode: string;
    selectedReasons: string[] = [];
    selectedmessageCode: string[] = [];
    routeStopName: string = "";
    messageText: string = '';
    loaded:boolean=true;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private garmentRepairService: GarmentRepairService,
        private toasterService: ToasterService
    ) { 
        this.currentRoute = null;
    }

    ngOnInit(): void {
        this.currentRoute = this.router.url;
        this.stopName = this.route.snapshot.paramMap.get('id');
        this.breadcrumbs.push({ label: 'Home', url: '/route' });
        this.breadcrumbs.push({ label: 'Logsheet', url: '/route/logsheet' });
        this.breadcrumbs.push({ label: 'Stop', url: '/route/logsheet/stop/'+ this.stopName });
        this.routeStopName = localStorage.getItem('routeStopName');
    }

    ionViewWillEnter(): void {
        
    }
    onReasonChange() {
        const selectedOption = this.getReasonText(this.messageCode);
        if (selectedOption) {
          this.messageText = selectedOption;
        }
        this.addToMultiselectList();
      }
    addToMultiselectList() {
        if (this.messageText && !this.selectedReasons.includes(this.messageText)) {
            this.selectedReasons.push(this.messageText);
            this.selectedmessageCode.push(this.messageCode);
          }
          if( this.selectedReasons.length>0){
          }
      }
      removeReason(index: number) {
        this.selectedReasons.splice(index, 1); 
        this.selectedmessageCode.splice(index, 1);
      }
      getReasonText(value: string): string {
        const reasonMap: { [key: string]: string } = {
          '06': 'Relable Garment ID',
          '15': 'Repair - Belt Loop / Drawstring',
          '11': 'Repair - Buttons, Button Holes, Snaps',
          '13': 'Repair - Check All',
          'MSG0010064': 'Repair - Check Seat / Inner Thigh',
          'MSG0010031': 'Repair - Check Zipper',
          '21': 'Repair - Emblems',
          '14': 'Repair - Pockets',
          '12': 'Repair - Seams or Hems',
          'MSG0010070': 'Repair - Sleeve/Cuff',
          'MSG0010042': 'Repair - Tear',
          'MSG0010080': 'Replace - Inspect for Replacement',
          '05': 'Send to Customer Service',
          'MSG0010033': 'Verify - All Emblems',
          'MSG0010046': 'Verify - Name Emblem Spelling'
        };
        return reasonMap[value];
      }
    async PostMessage(){
        this.loaded=false;
        if ((this.garmentCode !== undefined && this.garmentCode !== "" && this.garmentCode !== null) && (this.selectedmessageCode !== undefined && this.selectedmessageCode.length!= 0 && this.selectedmessageCode !== null)) {    
        await this.garmentRepairService.postRepairMessage(this.selectedmessageCode, this.garmentCode).then((response)=> {
                if (response) {
                    this.loaded=true;
                    this.toasterService.presentToast('primary', '', 'Repair created successfully', 2000);
                    this.messageCode = null;
                    this.garmentCode = null;
                    this.selectedmessageCode=[];
                    this.selectedReasons=[];
                    this.messageText=null;
                } else {
                    this.loaded=true;
                    this.toasterService.presentToast('danger', '', 'Something went wrong. Please try again.', 2000);
                }
            });
        }
        else{
            this.loaded=true;
            this.toasterService.presentToast('primary', '', 'Please select Reason and Garment Code ', 2000);
        }
        this.loaded=true;
    }



}